export type ValidationReturn = string | null;

export type CompanyName = {
  value: string;
  shouldValidate: boolean;
  isAuthenticated: boolean;
};

export const validateMandatory = (val: string): ValidationReturn => {
  return !val ? 'validationBlock.missingMandatory' : null;
};

export const validateAccept = (val: string): ValidationReturn => {
  return !val ? 'validationBlock.missingAcceptance' : null;
};
export const validateState = (val: string): ValidationReturn => {
  return !val ? 'validationBlock.noSelectedState' : null;
};

export const validateReason = (val: string): ValidationReturn => {
  return !val ? 'validationBlock.noSelectedReason' : null;
};

export const validateInvalidCharacters = (
  val: string | CompanyName,
  maxLength?: number,
  optional = false,
  regExp?: RegExp,
  disallowedRegExp?: RegExp,
  minLength?: number
): ValidationReturn => {
  if (val === undefined) {
    return optional === false ? validateMandatory('') : null;
  }
  const trimmedValue = typeof val === 'string' ? val.trim() : val.value.trim();
  const emptyMessage = validateMandatory(trimmedValue);

  if (emptyMessage) {
    return optional ? null : emptyMessage;
  }

  const pattern =
    /^(?!.*https?:\/\/|.*www\.|.*\.com)(?![ ¡!¿?"#$%&'()*+,-./:<=>@[\]^_`{|}~\d\s]*$)[^\u25CF<>{}[\]()=*;]+$/i;
  const hasInvalidLength = !!maxLength && trimmedValue.length > maxLength;
  const hasTooFewCharacters = !!minLength && trimmedValue.length < minLength;

  // If custom regExp is provided, use it instead of default pattern
  if (regExp) {
    if (!regExp.test(trimmedValue)) {
      return 'validationBlock.nameInvalid';
    }
  } else {
    // Only use default pattern if no custom regExp is provided
    if (!pattern.test(trimmedValue)) {
      return 'validationBlock.nameInvalid';
    }
  }
  // throw error if disallowed patterns are found
  if (disallowedRegExp && disallowedRegExp.test(trimmedValue)) {
    return 'validationBlock.nameInvalid';
  }
  if (hasInvalidLength) {
    return 'validationBlock.maxNumberOfCharactersExceeded';
  }
  if (hasTooFewCharacters) {
    return 'validationBlock.minNumberOfCharactersRequired';
  }

  return null;
};

export const validateCompanyName =
  (maxLength?: number) =>
  ({ value, shouldValidate }: CompanyName): ValidationReturn => {
    return shouldValidate ? validateInvalidCharacters(value, maxLength) : null;
  };
